import React from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { ReactComponent as Icon } from '#web-components/assets/icons/arrowDropDown.svg';

import styles from './ArrowDropDownIcon.styles';

type ArrowDropDownIconProps = {
  className?: string;
};

const useStyles = makeStyles(styles, { name: 'ArrowDropDownIcon' });

export default function ArrowDropDownIcon({ className }: ArrowDropDownIconProps) {
  const classes = useStyles();
  return (
    <span className={clsx(classes.icon, className)}>
      <Icon />
    </span>
  );
}
